import { render, staticRenderFns } from "./PainelHome.vue?vue&type=template&id=6a1c2db8"
import script from "./PainelHome.vue?vue&type=script&lang=js"
export * from "./PainelHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports